import { Component, OnInit, Inject } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { BoardsService } from 'src/app/service/boards.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogDataTaskStatus } from '../../task-status/task-status/task-status.component';

@Component({
  selector: 'app-status',
  templateUrl: './status.component.html',
  styleUrls: ['./status.component.scss'],
  standalone: false,  // NOSONAR
})
export class StatusComponent implements OnInit {

  showloaderMsg = '';
  board_task_id;
  region;
  usertemp;
  userInfo;
  userID;

  successMessage;
  errorMessage;

  prompt_Message;

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly boardService: BoardsService,
    public dialogRef: MatDialogRef<StatusComponent>,
    @Inject(MAT_DIALOG_DATA) public dataStore: DialogDataTaskStatus) { }

  ngOnInit(): void {  




    const userData = sessionStorage?.getItem('FGA');
    if (userData) {
      this.userID = JSON.parse(userData)?.user?.userPrincipalName;
    }




    // Mark As Incomplete - complete task to open task  
    if (this.dataStore.page == 'task-status') { // NOSONAR

      this.prompt_Message = "Marking As Incomplete!";

      console.info("params from sttaus page:", this.dataStore.params);


      this.board_task_id = this.dataStore.params.data.BOARD_TASK_ID;

      // if I'm from my-tasks, region will be coldef.SECTION

      if (this.dataStore.params.data.page == "MyTasksComponent") { // NOSONAR
        this.region = this.dataStore.params.data.SECTION;
      }
      else {
        console.info("RAW FIELD:", this.dataStore.params.colDef.field);
        this.region = this.dataStore.params.colDef.field;
      }

      let dataArr;

      if (this.region == 'USER') { // NOSONAR
        dataArr = {
          "intuserID": this.userID,
          "boardTaskID": this.board_task_id
        };
      }

      else {
        dataArr = {
          "intuserID": this.userID,
          "boardTaskID": this.board_task_id,
          "region": this.region
        };
      }

      //marking as incomplete: status change from C/F/L to O
      this.boardService.markAsIncomplete(dataArr).subscribe(result => {

        console.info("result", result);

        if (!result) {
          this.errorMessage = 'Error while marking as Incomplete!';

          setTimeout(() => {

            this.dialogRef.close({ event: "Mark As Incomplete - Failed" });

            this.successMessage = '';
            this.errorMessage = '';
          }, 1500);



        }

        else if (result) {

          this.successMessage = 'Marked as Incomplete!';
          setTimeout(() => {

            this.dialogRef.close({ event: "Mark As Incomplete - Success" });

            this.successMessage = '';
            this.errorMessage = '';
          }, 1500);


          // load data after updating
          // this.loadData();

        }
      });

    }


    if (this.dataStore.page == 'late-conf') { // NOSONAR

      this.prompt_Message = "Marking Task As Late!";

      this.successMessage = 'Marked as Incomplete!';
      setTimeout(() => {

        this.dialogRef.close({ event: "Mark As Incomplete - Success" });

        this.successMessage = '';
        this.errorMessage = '';
      }, 1500);

    }


    // Mark As Complete - open task to complete task  

    this.initial_sub()
    

  }

  initial_sub()

  {
    if (this.dataStore.page == 'task-status-2') { // NOSONAR


      this.prompt_Message = "Marking As Complete!";
      console.info("params from sttaus page:", this.dataStore.params);

      this.board_task_id = this.dataStore.params.data.BOARD_TASK_ID;

      // if I'm from my-tasks, region will be coldef.SECTION

      if (this.dataStore.params.data.page == "MyTasksComponent") { // NOSONAR
        this.region = this.dataStore.params.data.SECTION;
      }
      else {
        console.info("RAW FIELD 2:", this.dataStore.params.colDef.field);
        this.region = this.dataStore.params.colDef.field;
      }


      let dataArr;

      if (this.region == 'USER') { // NOSONAR
        dataArr = {
          "intuserID": this.userID,
          "boardTaskID": this.board_task_id
        };
      }

      else {
        dataArr = {
          "intuserID": this.userID,
          "boardTaskID": this.board_task_id,
          "region": this.region
        };
      }


      //marking as complete: status change from O to C
      this.boardService.markAsComplete(dataArr).subscribe(result => {

        console.info("result", result);

        if (!result) {
          this.errorMessage = 'Error while marking as complete!';

          setTimeout(() => {

            this.dialogRef.close({ event: "Mark As complete - Failed" });

            this.successMessage = '';
            this.errorMessage = '';
          }, 1500);



        }

        else if (result) {

          this.successMessage = 'Marked as complete!';
          setTimeout(() => {

            this.dialogRef.close({ event: "Mark As complete - Success" });

            this.successMessage = '';
            this.errorMessage = '';
          }, 1500);


          // fetch latest row data after adding
          // this.loadData();

        }
      });

    }
  }

}
